import { useEffect } from 'react';

// Gestionnaire pour supprimer les erreurs ResizeObserver non critiques
export const suppressResizeObserverErrors = () => {
  // Surcharger console.error pour filtrer les erreurs ResizeObserver
  const originalError = console.error;
  console.error = (...args) => {
    const message = args[0];
    if (typeof message === 'string' && 
        (message.includes('ResizeObserver loop completed with undelivered notifications') ||
         message.includes('ResizeObserver loop limit exceeded'))) {
      // Ignorer ces erreurs spécifiques
      return;
    }
    originalError.apply(console, args);
  };

  // Gestionnaire d'erreurs global pour les erreurs ResizeObserver
  const handleResizeObserverError = (event) => {
    if (event.message && event.message.includes('ResizeObserver')) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  };

  // Ajouter les gestionnaires d'événements
  window.addEventListener('error', handleResizeObserverError);
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && 
        event.reason.message && 
        event.reason.message.includes('ResizeObserver')) {
      event.preventDefault();
      return false;
    }
  });
};

// Hook React pour gérer les erreurs ResizeObserver
export const useResizeObserverErrorSuppression = () => {
  useEffect(() => {
    suppressResizeObserverErrors();
  }, []);
};

// Fonction de débounce pour éviter les mises à jour trop fréquentes
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};